import {Form, FormItem, Input, Select} from 'formik-antd';
import React from 'react';
import {AuthorizedUserAccessLevel} from '../../../api/generated';
import {StoresProps} from './AuthorizedUsers';

const {Option} = Select;

export const AuthorizedUserForm: React.FC<StoresProps> = ({stores, loadingStores}) => {
  return (
    <Form layout="vertical">
      <FormItem name="userEmail" label="User email">
        <Input name="userEmail" placeholder="email@example.com" />
      </FormItem>
      <FormItem name="accessLevel" label="Access level">
        <Select name="accessLevel">
          <Option value={AuthorizedUserAccessLevel.ADMIN_ACCESS}>Admin access</Option>
          <Option value={AuthorizedUserAccessLevel.READ_ACCESS}>Read only access</Option>
          <Option value={AuthorizedUserAccessLevel.WRITE_ACCESS}>Read and write access</Option>
        </Select>
      </FormItem>
      {stores.length > 0 && (
        <FormItem name="storeId" label="Store">
          <Select name="storeId" loading={loadingStores} allowClear>
            {stores?.map((store) => (
              <Option value={store.id}>{store.name}</Option>
            ))}
          </Select>
        </FormItem>
      )}
      <input type="submit" value="submit" hidden />
    </Form>
  );
};
